module.exports = __webpack_public_path__ + "img/cross.190c4b37.svg";